import React, { memo } from 'react';

// import HostilePannel from './components/hostilePannel';
// import CultureCircles from './components/cultureCircles';
// import SliderComp from '../complexitySlider';
import {
  LevelPannels,
  ThreeLevelImportancePannel,
} from '../../components/likelihoodPannel';
// import { Seq19 } from '../people/components/choices';
import VerticleBar from '../../components/DegreeIntegration';
import './enterprise.scss';

// const Co = () => <div>div</div>;
const comp = {
  11: LevelPannels,
  12: VerticleBar,
  13: ThreeLevelImportancePannel,
  // 18: SliderComp,
  // 19: Seq19,
  // 20: Seq20,
};

function Enterprise(props) {
  const Content = props.c;
  return (
    <Content
      {...props}
      comp={comp}
      showSubSection={false}
      showContentAsSubtitle
    />
  );
}

export default memo(Enterprise);
